'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Schedule = exports.ScheduleUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactIntl = require('react-intl');

var _Venue = require('derivers/Venue');

var _Venue2 = _interopRequireDefault(_Venue);

var _Schedules = require('derivers/Schedules');

var _Schedules2 = _interopRequireDefault(_Schedules);

var _multitrack = require('helpers/multitrack');

var _time = require('helpers/time');

var _verify = require('helpers/verify');

var _getScheduleAction = require('helpers/getScheduleAction');

var _getScheduleAction2 = _interopRequireDefault(_getScheduleAction);

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _DateBar = require('./DateBar');

var _ScheduleRow = require('./ScheduleRow');

var _Messages = require('./Messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COLLAPSED_SIZE = 6;
var MAX_UPCOMING_SIZE = 12;

var ScheduleUnwrapped = exports.ScheduleUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(ScheduleUnwrapped, _React$Component);

  function ScheduleUnwrapped() {
    var _ref;

    var _temp, _this, _this3, _ret;

    (0, _classCallCheck3.default)(this, ScheduleUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = ScheduleUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ScheduleUnwrapped)).call.apply(_ref, [this].concat(args))), _this3), _this3.formatDate = function (scheduleDate) {
      var isToday = function isToday(date) {
        return date === (0, _moment2.default)().format('YYYY-MM-DD');
      };
      var isTomorrow = function isTomorrow(date) {
        return date === (0, _moment2.default)().add(1, 'd').format('YYYY-MM-DD');
      };
      var template = function template(qualifier) {
        return qualifier + ', MMMM D';
      };
      var dateObject = (0, _moment2.default)(scheduleDate, 'YYYY-MM-DD');

      if (isToday(scheduleDate)) {
        return dateObject.format(template('[Today]'));
      } else if (isTomorrow(scheduleDate)) {
        return dateObject.format(template('[Tomorrow]'));
      }
      return dateObject.format(template('dddd'));
    }, _this3.handleRetryLoad = function () {
      var _this$props = _this.props,
          selectedDate = _this$props.selectedDate,
          onRequestScheduleForDate = _this$props.onRequestScheduleForDate;


      onRequestScheduleForDate(selectedDate);
    }, _this3.generateVisibleSchedule = function () {
      var _reduce;

      var _this$props2 = _this.props,
          expanded = _this$props2.expanded,
          multiDay = _this$props2.multiDay,
          selectedDate = _this$props2.selectedDate,
          timeZone = _this$props2.timeZone;


      var schedule = _this.props.schedule || [];

      return (expanded ? schedule : schedule.slice(0, COLLAPSED_SIZE)).reduce(function (memo, klass) {
        var classDate = (0, _time.timezoneDate)(timeZone, new Date(klass.starttime * 1e3));

        if (classDate !== selectedDate) {
          if (!multiDay) {
            // Ignore schedules from dates other than the selected one if multiDay isn't enabled.
            return memo;
          }
          if (memo[selectedDate].length > COLLAPSED_SIZE) {
            // We don't add future classes if we have enough classes on the selected day.
            return memo;
          }
          if (memo.totalClasses >= MAX_UPCOMING_SIZE) {
            // We don't add more future classes if we have hit the limit for number of upcoming classes to display.
            return memo;
          }
        }

        memo.totalClasses += 1;
        memo[classDate] = memo[classDate] || [];
        memo[classDate].push(klass);

        return memo;
      }, (_reduce = {}, (0, _defineProperty3.default)(_reduce, selectedDate, []), (0, _defineProperty3.default)(_reduce, 'totalClasses', 0), _reduce));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(ScheduleUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Venue Details', 'View Module', 'schedule', 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classId = _props.classId,
          expanded = _props.expanded,
          extraClass = _props.extraClass,
          hideCtas = _props.hideCtas,
          hideDateHeader = _props.hideDateHeader,
          includeJsonMetadata = _props.includeJsonMetadata,
          isViewingNextCycle = _props.isViewingNextCycle,
          loading = _props.loading,
          memberStatus = _props.memberStatus,
          multiDay = _props.multiDay,
          nameOfClass = _props.nameOfClass,
          noLink = _props.noLink,
          numberOfDaysToShow = _props.numberOfDaysToShow,
          onRequestScheduleForDate = _props.onRequestScheduleForDate,
          _onReserveClicked = _props.onReserveClicked,
          onToggleExpand = _props.onToggleExpand,
          ratingsByClass = _props.ratingsByClass,
          schedule = _props.schedule,
          selectedDate = _props.selectedDate,
          showPrices = _props.showPrices,
          showPurchaseCta = _props.showPurchaseCta,
          timeZone = _props.timeZone,
          venueUrl = _props.venueUrl,
          didError = _props.didError;

      var _generateVisibleSched = this.generateVisibleSchedule(),
          totalClasses = _generateVisibleSched.totalClasses,
          visibleSchedule = (0, _objectWithoutProperties3.default)(_generateVisibleSched, ['totalClasses']);

      var selectedDateHasClasses = !(0, _verify.isEmpty)(visibleSchedule[selectedDate]);
      var scheduleDates = (0, _keys2.default)(visibleSchedule);

      var content = void 0;
      if (loading) {
        content = _react2.default.createElement(_Messages.SchedulesLoadingMessage, null);
      } else if (didError) {
        content = _react2.default.createElement(_Messages.SchedulesErrorMessage, { onClick: this.handleRetryLoad });
      } else if (totalClasses > 0) {
        var _ref2;

        var expandCollapseEnabled = schedule.length > COLLAPSED_SIZE;

        content = _react2.default.createElement(
          'div',
          null,
          includeJsonMetadata && !(0, _verify.isEmpty)(scheduleDates) && _react2.default.createElement(
            _reactHelmet2.default,
            null,
            _react2.default.createElement(
              'script',
              { type: 'application/ld+json' },
              (0, _stringify2.default)((_ref2 = []).concat.apply(_ref2, (0, _toConsumableArray3.default)((0, _values2.default)(visibleSchedule))).map(function (sch) {
                return {
                  '@context': 'http://schema.org',
                  '@type': 'Event',
                  name: sch.class.name,
                  startDate: new Date(sch.starttime * 1e3).toISOString(),
                  endDate: new Date(sch.endtime * 1e3).toISOString(),
                  url: 'https://classpass.com/classes/' + sch.venue.alias + '/' + sch.class.alias + '/' + sch.id,
                  location: {
                    '@type': 'Place',
                    name: '' + sch.venue.name,
                    address: '' + _Venue2.default.address(sch.venue)
                  }
                };
              }))
            )
          ),
          isViewingNextCycle && _react2.default.createElement(_Messages.NextCycleMessage, null),
          scheduleDates.map(function (date) {
            return _react2.default.createElement(
              'div',
              { key: date, className: 'schedule__row-wrapper' },
              multiDay && (date === selectedDate && !selectedDateHasClasses && _react2.default.createElement(_Messages.NoSchedulesSelectedDateMessage, { date: _this2.formatDate(date) }) || _react2.default.createElement(
                'div',
                { className: 'schedule__row-header' },
                _this2.formatDate(date)
              )),
              visibleSchedule[date].map(function (sch) {
                var purchase = sch.availability && sch.availability.purchase || {};
                return _react2.default.createElement(_ScheduleRow.ScheduleRow, (0, _extends3.default)({}, _Schedules2.default.availabilityData(sch), {
                  activities: sch.class.activities,
                  availabilityLabel: sch.availability && sch.availability.label,
                  callToAction: sch && (0, _getScheduleAction2.default)(memberStatus, sch, { isAlcEnabled: showPurchaseCta }),
                  className: sch.class.name,
                  creditPrice: sch.availability && sch.availability.credits,
                  endTime: sch.endtime,
                  hideCta: hideCtas,
                  itemUrl: noLink ? null : '/classes/' + sch.venue.alias + '/' + sch.class.alias + '/' + sch.id,
                  key: 'schedule_' + sch.id,
                  onReserveClicked: function onReserveClicked() {
                    return _onReserveClicked(sch);
                  },
                  purchaseAmount: showPrices && purchase.amount,
                  purchaseCurrency: showPrices && purchase.currency,
                  rating: ratingsByClass && ratingsByClass[sch.class.alias],
                  schedule: sch,
                  startTime: sch.starttime,
                  teacherName: sch.teacher.name,
                  timeZone: timeZone
                }));
              })
            );
          }),
          onToggleExpand && expandCollapseEnabled && _react2.default.createElement(
            'div',
            {
              className: 'schedule__row schedule__row--fullwidth schedule__row__more',
              onClick: function onClick() {
                (0, _multitrack.ga)('Venue Details', 'See Full Schedule Click');
                onToggleExpand();
              }
            },
            _react2.default.createElement(
              'a',
              null,
              expanded ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'schedule.collapse',
                defaultMessage: 'Show less'
              }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'schedule.expand',
                defaultMessage: 'Show more'
              })
            )
          )
        );
      } else {
        content = classId ? _react2.default.createElement(_Messages.NoSchedulesOfClassTodayMessage, {
          nameOfClass: nameOfClass,
          venueUrl: venueUrl
        }) : _react2.default.createElement(_Messages.NoSchedulesTodayMessage, null);
      }

      var _selectedDate$split = selectedDate.split('-'),
          _selectedDate$split2 = (0, _slicedToArray3.default)(_selectedDate$split, 3),
          year = _selectedDate$split2[0],
          month = _selectedDate$split2[1],
          day = _selectedDate$split2[2];

      var date = new Date(year, month - 1, day);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('schedule', extraClass) },
        !hideDateHeader && _react2.default.createElement(
          'div',
          { className: 'schedule__date' },
          _react2.default.createElement(_reactIntl.FormattedDate, {
            value: selectedDate ? date : new Date(),
            weekday: 'long',
            month: 'long',
            day: 'numeric'
          })
        ),
        _react2.default.createElement(_DateBar.DateBar, {
          extraClass: !multiDay || !selectedDateHasClasses ? '' : 'schedule__datebar--no-border-bottom',
          numberOfDaysToShow: numberOfDaysToShow || 14,
          selectedDate: date,
          onDateClick: function onDateClick(forDate) {
            (0, _multitrack.ga)('Venue Details', 'Change Schedule Click');
            onRequestScheduleForDate(forDate);
          }
        }),
        _react2.default.createElement(
          'div',
          { className: 'schedule__rows' },
          content
        )
      );
    }
  }]);
  return ScheduleUnwrapped;
}(_react2.default.Component);

ScheduleUnwrapped.propTypes = {
  classId: _propTypes2.default.number,
  expanded: _propTypes2.default.bool,
  extraClass: _propTypes2.default.string,
  hideCtas: _propTypes2.default.bool,
  hideDateHeader: _propTypes2.default.bool,
  includeJsonMetadata: _propTypes2.default.bool,
  isViewingNextCycle: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  didError: _propTypes2.default.bool,
  memberStatus: _propTypes2.default.string,
  multiDay: _propTypes2.default.bool,
  nameOfClass: _propTypes2.default.string,
  noLink: _propTypes2.default.bool,
  numberOfDaysToShow: _propTypes2.default.number,
  onRequestScheduleForDate: _propTypes2.default.func,
  onReserveClicked: _propTypes2.default.func,
  onToggleExpand: _propTypes2.default.func,
  ratingsByClass: _propTypes2.default.object,
  schedule: _propTypes2.default.array,
  selectedDate: _propTypes2.default.string,
  showPrices: _propTypes2.default.bool,
  showPurchaseCta: _propTypes2.default.bool,
  timeZone: _propTypes2.default.string.isRequired,
  userPermissions: _propTypes2.default.object,
  venueUrl: _propTypes2.default.string
};

var Schedule = exports.Schedule = (0, _TrackDwell2.default)(ScheduleUnwrapped);